import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import { Button } from '@/shared/components/Button';
import withReactContent from "sweetalert2-react-content";
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditUser = (props) => {
  const [user, setUser] = useState();

  const GetUserData = (user_id) => {
    AdminInterface.instance.getUser(user_id).then((response) => {
      setUser(response.data);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response.data?.detail,
      });
    })
  }

  useEffect(() => {
    GetUserData(props.user_id);
  }, [props.user_id]);

  const submitNewUser = (user) => {
    AdminInterface.instance.updateUser(props.user_id, user).then((response) => {
      Swal.fire('Updated!', '', 'success')
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response.data?.detail,
      });
    })
  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>Edit User</CardTitle>
          </CardTitleWrap>
          <Form onSubmit={submitNewUser} initialValues={user}>
            {({ handleSubmit, form }) => (
              <FormContainer horizontal onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>First Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="given_name" component="input" type="text" placeholder="firstname" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Last Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="family_name" component="input" type="text" placeholder="lastname" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>E-mail</FormGroupLabel>
                  <FormGroupField>
                    <Field name="email" component="input" type="email" placeholder="example@mail.com" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>HubSpot Contact Id</FormGroupLabel>
                  <FormGroupField>
                    <Field name="hubSpotContactId" component="input" placeholder="HubSpot Contact Id" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Subscription Plan</FormGroupLabel>
                  <FormGroupField vertical={1}>
                    <Field
                      name="plan"
                      component={renderRadioButtonField}
                      label="Freemium"
                      radioValue="Freemium"
                    />
                    <Field
                      name="plan"
                      component={renderRadioButtonField}
                      label="Starter"
                      radioValue="Starter"
                    />
                    <Field
                      name="plan"
                      component={renderRadioButtonField}
                      label="Professional"
                      radioValue="Professional"
                    />
                    <Field
                      name="plan"
                      component={renderRadioButtonField}
                      label="Enterprise"
                      radioValue="Enterprise"
                    />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Metadata</FormGroupLabel>
                  <FormGroupField vertical={1}>
                    <Field
                      name="blocked"
                      type="checkbox"
                      component={renderCheckBoxField}
                      label="Is Blocked?"
                    />
                    <Field
                      name="isManager"
                      type="checkbox"
                      component={renderCheckBoxField}
                      label="Is Manager?"
                    />
                    <Field
                      name="hubSpotContactCreated"
                      type="checkbox"
                      component={renderCheckBoxField}
                      label="Is HubSpot Contact Created?"
                    />
                    <Field
                      name="hubSpotContactAddedToList"
                      type="checkbox"
                      component={renderCheckBoxField}
                      label="Is HubSpot Contact Added To List?"
                    />
                  </FormGroupField>
                </FormGroup>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                  <Button variant="secondary" type="button" onClick={() => props.setEditUserIdHandler(null)}>
                    Cancel
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EditUser;
